
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, FileText, MessageCircle, User, Settings2 } from "lucide-react";
import { useState, useEffect } from "react";
import { checkManagerAuth } from "@/utils/managerAuth";
import { supabase } from "@/integrations/supabase/client";

const MobileBottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      if (location.pathname.startsWith('/manager')) {
        const auth = await checkManagerAuth();
        setIsAuthenticated(auth);

        if (auth) {
          const memberId = sessionStorage.getItem('organization_member_id');
          if (memberId) {
            const { data, error } = await supabase
              .from('organization_members')
              .select('role')
              .eq('id', memberId)
              .single();
            
            if (!error && data && data.role === 'ADMIN') {
              setIsAdmin(true);
            } else {
              setIsAdmin(false);
            }
          }
        }
      }
    };
    
    checkAuth();
  }, [location.pathname]);

  const isManagerRoute = location.pathname.startsWith('/manager');
  const shouldShowNav = isManagerRoute && isAuthenticated;

  if (!shouldShowNav) return null;

  const navigationItems = [
    {
      label: "News",
      icon: Home,
      path: "/manager/dashboard",
      isActive: location.pathname === "/manager/dashboard"
    },
    {
      label: "Documents",
      icon: FileText,
      path: "/manager/documents",
      isActive: location.pathname === "/manager/documents"
    },
    {
      label: "Ask Frank",
      icon: MessageCircle,
      path: "/manager/ask-frank",
      isActive: location.pathname === "/manager/ask-frank"
    },
    {
      label: "Profile",
      icon: User,
      path: "/manager/profile",
      isActive: location.pathname === "/manager/profile"
    }
  ];

  if (isAdmin) {
    navigationItems.push({
      label: "Admin",
      icon: Settings2,
      path: "/manager/admin",
      isActive: location.pathname === "/manager/admin"
    });
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border md:hidden">
      <div className="flex items-center justify-around px-2 py-2">
        {navigationItems.map((item) => {
          const Icon = item.icon;
          return (
            <Button
              key={item.path}
              variant="ghost"
              size="sm"
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center gap-1 h-auto py-2 px-3 min-w-0 flex-1 ${
                item.isActive 
                  ? 'text-[#2F80ED] bg-[#2F80ED]/10' 
                  : 'text-[#637588] hover:text-[#1B365D] hover:bg-muted/50'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-xs font-medium truncate">{item.label}</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNavigation;
